import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(window.innerWidth > 768); // default depends on screen size

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsOpen(true); // Always open on desktop
      } else {
        setIsOpen(false); // Always closed on mobile by default
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => setIsOpen(!isOpen);

  // Close sidebar when overlay is clicked (only mobile)
  const handleOverlayClick = () => {
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  };

  return (
    <div className="app">
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
      {/* Overlay (only for mobile) */}
      {isOpen && window.innerWidth <= 768 && (
        <div className="overlay" onClick={handleOverlayClick}></div>
      )}
      <div className={`main-content ${!isOpen ? "sidebar-closed" : ""}`}>
        <Header toggleSidebar={toggleSidebar} />
        <div className="content">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
